import { productCatalogueApi } from 'api';
import { ProductCatalogueListResult } from 'pco-product-service-internal-consumer';

export const getEligibleProducts = async (brUid: string | undefined): Promise<ProductCatalogueListResult> => {
  return await productCatalogueApi.getEligibleProductsForBr({ brUid: brUid ?? '' });
};
